import { createFileRoute, redirect } from "@tanstack/react-router";
import { sessionQuery } from "@/api/session";
import { HomePage } from "@/features/marketing/home-page";
import { SEO } from "@/features/marketing/seo";

/**
 * The apex is the app: a signed-in visitor (and the installed PWA, whose start_url is `/`)
 * goes straight to /app. Everyone else gets the landing page — also when the session cannot be looked up at all:
 * offline, or a search engine rendering the page, which never fetches `/api/*` (robots.txt). A failed lookup must not
 * replace the prerendered page with the error screen, which Google would then index as the home page; one attempt,
 * no retries, so the landing page never waits on it either. Only a session the API confirms forwards to /app.
 */
export const Route = createFileRoute("/_marketing/")({
  beforeLoad: async ({ context }) => {
    const session = await context.queryClient.ensureQueryData({ ...sessionQuery, retry: false }).catch(() => null);
    if (session) throw redirect({ to: "/app" });
  },
  head: SEO.home,
  component: HomePage,
});
